module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/quote-1-679ab210fbd9d70bd78fab4ccbab3ea7.svg";